import { Button, Input, InputProps } from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';

import { formatIsoDate } from '@app/utils-agnostic';
import { Tables } from '@app/web-components';

export const getSearchFilterDropdown =
  (props?: InputProps): ((props: FilterDropdownProps) => React.ReactNode) =>
  ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        {...props}
        value={selectedKeys[0] as string | number}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [props?.type === 'number' ? Number(e.target.value) : e.target.value] : [])
        }
        onPressEnter={() => confirm()}
      />
      <div className="ant-table-filter-dropdown-btns" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={clearFilters} size="small" type="link" style={{ paddingLeft: 0 }}>
          Reset
        </Button>
        <Button type="primary" onClick={() => confirm()} size="small">
          OK
        </Button>
      </div>
    </div>
  );

export const ActiveColumn = {
  title: 'Active',
  dataIndex: 'isActive',
  width: 100,
  render: (isActive: boolean) => <Tables.BooleanRenderer value={isActive} />,
  sorter: true,
  filters: [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ],
  filterMultiple: false,
};

export const CreatedByColumn = {
  title: 'Created By',
  dataIndex: ['createdByUser', 'name'],
  width: 200,
  ellipsis: true,
  sorter: true,
  filterDropdown: getSearchFilterDropdown({
    'aria-label': 'Search users',
    placeholder: 'Search users',
  }),
};

export const CreatedOnColumn = {
  title: 'Created On',
  dataIndex: 'createdOn',
  width: 200,
  ellipsis: true,
  render: (date: string) => formatIsoDate(date),
  sorter: true,
};

export const UpdatedByColumn = {
  title: 'Updated By',
  dataIndex: ['updatedByUser', 'name'],
  width: 200,
  ellipsis: true,
  sorter: true,
  filterDropdown: getSearchFilterDropdown({
    'aria-label': 'Search users',
    placeholder: 'Search users',
  }),
};

export const UpdatedOnColumn = {
  title: 'Updated On',
  dataIndex: 'updatedOn',
  width: 200,
  ellipsis: true,
  render: (date: string) => formatIsoDate(date),
  sorter: true,
};

export const AuditFilters = {
  'createdByUser.name': (value: boolean | React.Key | null) => ({
    createdByUser: { name: { contains: value ?? '', mode: 'insensitive' } },
  }),
  'updatedByUser.name': (value: boolean | React.Key | null) => ({
    updatedByUser: { name: { contains: value ?? '', mode: 'insensitive' } },
  }),
};
